export default __webpack_public_path__ + "static/media/export.4bc61c50.svg";